// Rosters.jsx
import React, { useState } from 'react';

import { FaUserMd, FaDownload, FaEnvelope, FaPrint } from 'react-icons/fa';

import ORTable from './roster-components/ORTable';
import PRTable from './roster-components/PRTable';
import CTTable from './roster-components/CTTable';
import PractitionersTable from './roster-components/PractitionersTable';

const Rosters = () => {
        const [activeTab, setActiveTab] = useState('OR');
        const [selectedDoctor, setSelectedDoctor] = useState('');
        const [selectedWeek, setSelectedWeek] = useState('1');

        const doctors = [
                'Dr Paul',
                'Dr John',
                'Dr Smith',
                'Dr Tom',
                'Dr Jack'
        ];

        const weeks = [
                { value: '1', label: '1 Week' },
                { value: '2', label: '2 Weeks' },
                { value: '3', label: '3 Weeks' },
                { value: '4', label: '4 Weeks' }
        ];

        const categories = [
                { value: 'OR', label: 'OR' },
                { value: 'PR', label: 'PR' },
                { value: 'CT', label: 'CT' },
                { value: 'Practitioners', label: 'Practitioners' }
        ];

        const renderActiveTable = () => {
                switch (activeTab) {
                        case 'OR':
                                return <ORTable />;
                        case 'PR':
                                return <PRTable />;
                        case 'CT':
                                return <CTTable />;
                        case 'Practitioners':
                                return <PractitionersTable />;
                        default:
                                return <ORTable />;
                }
        };

        return (
                <div className="p-6">
                        {/* Header Section */}
                        <div className="bg-base-100 rounded-lg shadow mb-6">
                                <div className="p-4 flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                                <FaUserMd className="w-6 h-6" />
                                                <h1 className="text-2xl font-semibold">Rosters</h1>
                                        </div>

                                        <div className="flex items-center gap-4">
                                                {/* Print and Email buttons */}
                                                <button className="btn btn-ghost btn-sm">
                                                        <FaPrint className="w-4 h-4" />
                                                </button>
                                                <button className="btn btn-ghost btn-sm">
                                                        <FaEnvelope className="w-4 h-4" />
                                                </button>

                                                {/* Category Dropdown */}
                                                <select
                                                        className="select select-bordered"
                                                        value={activeTab}
                                                        onChange={(e) => setActiveTab(e.target.value)}
                                                >
                                                        {categories.map(cat => (
                                                                <option key={cat.value} value={cat.value}>
                                                                        {cat.label}
                                                                </option>
                                                        ))}
                                                </select>

                                                {/* Weeks Dropdown */}
                                                <select
                                                        className="select select-bordered"
                                                        value={selectedWeek}
                                                        onChange={(e) => setSelectedWeek(e.target.value)}
                                                >
                                                        {weeks.map(week => (
                                                                <option key={week.value} value={week.value}>
                                                                        {week.label}
                                                                </option>
                                                        ))}
                                                </select>

                                                {/* Doctors Dropdown */}
                                                <select
                                                        className="select select-bordered"
                                                        value={selectedDoctor}
                                                        onChange={(e) => setSelectedDoctor(e.target.value)}
                                                >
                                                        <option value="">Select Doctor</option>
                                                        {doctors.map(doctor => (
                                                                <option key={doctor} value={doctor}>
                                                                        {doctor}
                                                                </option>
                                                        ))}
                                                </select>

                                                {/* Download Button */}
                                                <button className="btn btn-warning btn-sm">
                                                        <FaDownload className="w-4 h-4 mr-2" />
                                                        Download
                                                </button>
                                        </div>
                                </div>
                        </div>

                        {/* Roster Tables */}
                        <div className="bg-base-100 rounded-lg shadow">
                                <div className="p-4">
                                        {renderActiveTable()}
                                </div>
                        </div>
                </div>
        );
};

export default Rosters;